module.exports = __webpack_public_path__ + "img/wu-16x180.prt.4d158a1c.jpg";